import { createSlice } from "@reduxjs/toolkit";

export const boxViewReducer = createSlice({
  name: "boxView",
  initialState: {
    openAlertData: [],
    savedAlertData: [],
    raToolRowSelectionData: {},
    compLevel: "Loc",
  },
  reducers: {
    RA_ALERT_DATA: (state, action) => {
      let raAlertUpdatedData = [...state.openAlertData];
      let alertData = [];
      let isInsert = true;
      if (
        raAlertUpdatedData.length > 0 &&
        action.payload &&
        null !== action.payload &&
        action.payload.repair_alert_id &&
        null !== action.payload.repair_alert_id
      ) {
        raAlertUpdatedData.map((item) => {
          if (item.repair_alert_id === action.payload.repair_alert_id) {
            alertData.push(action.payload);
            isInsert = false;
          } else {
            alertData.push(item);
          }
          return "";
        });
        if (isInsert) {
          alertData.push(action.payload);
        }
      } else {
        alertData.push(action.payload);
      }
      return {
        ...state,
        openAlertData: alertData,
      };
    },
    RA_TOOL_ROW_SELECTION_DATA: (state, action) => {
      return {
        ...state,
        raToolRowSelectionData: action.payload,
      };
    },
    RA_TOOL_COMP_LEVEL: (state, action) => {
      return {
        ...state,
        compLevel: action.payload,
      };
    },
    RA_TOOL_SELECTECD_MERC_MODE: (state, action) => {
      return {
        ...state,
        mercMode: action.payload,
      };
    },
    RA_TOOL_SHOP_IDS: (state, action) => {
      return {
        ...state,
        shopIds: action.payload,
      };
    },
    RA_TOOL_FILTERED_DATA: (state, action) => {
      return {
        ...state,
        filteredData: action.payload,
      };
    },
    RA_TOOL_EXPORTED_DATA: (state, action) => {
      return {
        ...state,
        raToolExportedData: action.payload,
      };
    },
    RA_TOOL_MODEL_MSG: (state, action) => {
      return {
        ...state,
        raToolModelMsg: action.payload,
      };
    },
    default: (state, action) => {
      return state;
    },
  },
});

export const {
  RA_ALERT_DATA,
  RA_TOOL_ROW_SELECTION_DATA,
  RA_TOOL_COMP_LEVEL,
  RA_TOOL_SELECTECD_MERC_MODE,
  RA_TOOL_SHOP_IDS,
  RA_TOOL_FILTERED_DATA,
  RA_TOOL_EXPORTED_DATA,
  RA_TOOL_MODEL_MSG,
} = boxViewReducer.actions;

export default boxViewReducer.reducer;
